export const VEHICLE_TYPES = ["Truck", "Carreta", "Bitrem", "VUC"];
export const BODY_TYPES = ["Baú", "Baú Sider", "Sider", "Graneleiro", "Plataforma"];

export const EMPTY_FILTERS = {
  number: "",
  origin: "",
  destination: "",
  vehicleType: "",
  bodyType: "",
  collectionDate: "",
};

export function formatCurrency(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatFreightValueDisplay(value, pricingType) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";

  if (String(pricingType || "").trim().toLowerCase() === "ton") {
    return `${num.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} / Ton`;
  }

  return formatCurrency(num);
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  if (dateStr.includes("/")) return dateStr;
  const [year, month, day] = String(dateStr).split("-");
  if (!year || !month || !day) return dateStr;
  return `${day}/${month}/${year}`;
}
